import type { Session } from "@supabase/supabase-js";

import { atom, useSetAtom } from "jotai";
import { useEffect } from "react";

import Bugsnag from "@/lib/bugsnag";
import { supabase } from "@/lib/supabase";

export const sessionAtom = atom<"loading" | null | Session>("loading");

export const currentUserIdAtom = atom((get) => {
  const session = get(sessionAtom);
  if (session === "loading") return null;
  return session?.user?.id ?? null;
});

export function useSessionSync() {
  const setSession = useSetAtom(sessionAtom);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      syncBugsnagUser(data.session);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, newSession) => {
      setSession(newSession);
      syncBugsnagUser(newSession);
    });

    return () => subscription.unsubscribe();
  }, [setSession]);
}

function syncBugsnagUser(session: null | Session) {
  if (session) {
    Bugsnag.setUser(session.user.id, session.user.phone);
  } else {
    Bugsnag.setUser(undefined);
  }
}
